export default __webpack_public_path__ + "img/img/double-heart.ebbd4fbd.svg";